import { MaintenanceBlockCombinedProps } from './types';

const usePresenter = (props: MaintenanceBlockCombinedProps): MaintenanceBlockCombinedProps => {
  return props;
};

export default usePresenter;
